import React, { useRef, useState } from "react";
import Spacer from "./Spacer";
import styles from "../styles/FilterSection.module.scss";
import Image from "next/image";
import clsx from "clsx";
import { useSpring, a } from "react-spring";
import { useIsMounted, usePrevious } from "../utils/hooks";

interface Props {
  name: string;
  children: React.ReactNode;
}

const FilterSection: React.FC<Props> = ({ name, children }) => {
  const [opened, setOpen] = useState(true);
  const previous = usePrevious(opened);
  const ref = useRef<HTMLDivElement>(null);
  const mounted = useIsMounted();
  const { height, opacity, spaceHeight } = useSpring({
    from: { height: 0, opacity: 0, spaceHeight: 0 },
    to: {
      height: opened ? ref.current?.clientHeight ?? 0 : 0,
      opacity: opened ? 1 : 0,
      spaceHeight: opened ? 16 : 0,
    },
    immediate: !mounted,
  });

  return (
    <div className={"column"}>
      <div
        className={"row ai-center cursor-pointer user-select-none"}
        onClick={() => setOpen(!opened)}
      >
        <div className={styles.name}>{name}</div>
        <Spacer width={8} />
        <Image
          src={"/arrow-2-grey.svg"}
          width={22}
          height={22}
          alt={"filter collapse section icon"}
          className={clsx(styles.arrow, { [styles.arrowExpanded]: !opened })}
        />
      </div>
      <a.div style={{ height: spaceHeight }} />
      <a.div
        style={{
          height: opened && previous === opened ? "auto" : height,
          opacity,
          overflow: (ref.current?.clientHeight ?? 0) > 50 ? "hidden" : "unset",
          pointerEvents: opened ? "auto" : "none",
        }}
      >
        <div ref={ref}>{children}</div>
      </a.div>
    </div>
  );
};

export { FilterSection };
